import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

interface TooltipProps {
	children: ReactNode;
	content: ReactNode;
	side?: "top" | "right" | "bottom" | "left";
	sideOffset?: number;
	delayDuration?: number;
	className?: string;
}

export function Tooltip({ children, content, side = "top", sideOffset = 5, delayDuration = 200, className = "" }: TooltipProps) {
	return (
		<TooltipPrimitive.Root delayDuration={delayDuration}>
			<TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
			<TooltipPrimitive.Portal>
				<TooltipPrimitive.Content side={side} sideOffset={sideOffset} className={`bg-gray-900 text-white text-xs rounded px-3 py-2 max-w-xs shadow-lg z-50 ${className}`}>
					{content}
					<TooltipPrimitive.Arrow className="fill-gray-900" />
				</TooltipPrimitive.Content>
			</TooltipPrimitive.Portal>
		</TooltipPrimitive.Root>
	);
}

export const TooltipProvider = TooltipPrimitive.Provider;

export default Tooltip;
